import styled from 'styled-components';

import { theme } from '../../../../styles';

export const StyledReameContainer = styled.div`
  background-color: ${theme.colors.grey[0]};
  overflow: auto;
`;
